import React from "react";
import { useLanguage } from "../LanguageContext";
import useScrollReveal from "../../utils/useScrollReveal";

import "../../assets/css/experience.css";
import "../../assets/css/font.css";

function Experience() {
  const { t } = useLanguage();
  const [ref, visible] = useScrollReveal();

  return (
    <section
      id="experience"
      ref={ref}
      className={`section section-alt experience reveal ${visible ? "is-visible" : ""}`}
    >
      <div className="container">
        <span className="eyebrow">{t.experience.eyebrow}</span>
        <h2 className="section-heading section-intro">{t.experience.title}</h2>

        <ol className="timeline">
          {t.experience.items.map((job) => (
            <li className="timeline-item" key={`${job.company}-${job.period}`}>
              <div className="timeline-marker" aria-hidden="true" />
              <header className="timeline-header">
                <div>
                  <span className="timeline-role">{job.role}</span>
                  <span className="timeline-company"> · {job.company}</span>
                </div>
                <div className="timeline-meta mono">
                  <span>{job.period}</span>
                  <span>{job.meta}</span>
                </div>
              </header>
              <ul className="timeline-bullets">
                {job.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
              <div className="timeline-stack">
                {job.stack.map((tech) => (
                  <span className="tech-tag" key={tech}>
                    {tech}
                  </span>
                ))}
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default Experience;
